import { createSagaActionTypes } from '../../../utils/actionFactory';
export const GET_ROLES = 'GET_ROLES';
export const DELETE_ROLE = 'DELETE_ROLE';

export const actions = createSagaActionTypes('ROLES', [GET_ROLES, DELETE_ROLE]);
